// **********************************************************
// Product Variation
// **********************************************************

// Populate variation data on single product page
const populateVariation = (data, popup) => {
  const productModule = document.querySelector('.product-module');
  const priceEle = (popup || productModule).querySelector('.product-module__price');

  priceEle.innerHTML = data.prices.current_price;
  priceEle.dataset.currentPrice = data.prices.current_price_data;

  productModule.querySelector('.product-module__add-to-cart .d-sm-none').innerHTML = `(${data.prices.current_price})`;
  (popup || productModule).querySelector('.variation-id').value = data.variation_id;
};

// Get variation data axios
const axiosGetVariation = async (formData, popup) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'getProductVariation');
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('id', (popup || document).querySelector('.product-id').value);
  formDataInput.append(
    'personalization',
    (popup || document).querySelector('.personalization-input.is-open-data') ? 1 : 0,
  );

  const addToCartButton = document.querySelector(
    popup ? '.product-popup__add-to-cart .btn' : '.product-module__add-to-cart .btn',
  );
  if (addToCartButton) {
    addToCartButton.classList.add('is-loading');
  }

  try {
    const response = await axios.post(localData.apiURL, formDataInput);
    if (addToCartButton) {
      addToCartButton.classList.remove('is-loading');
    }
    populateVariation(response.data.data, popup);
  } catch (err) {
    console.error(err);
  }
};
// get variation selected attributes and call axiosGetVariation
const getVariation = (popup) => {
  const selectors = (popup || document).querySelectorAll('.product-module__dropdown');
  const selectorsData = {};
  let isAnyInputNull = false;
  selectors.forEach((section) => {
    const inputField = section.querySelector('input:checked');
    if (inputField === null) {
      isAnyInputNull = true;
      return;
    }
    selectorsData[`attribute_${inputField.name.replace('popup-', '')}`] = inputField.value;
    section.classList.remove('is-validation-failed');
  });
  if (isAnyInputNull) {
    return;
  }

  axiosGetVariation(selectorsData, popup);
};

// Click on single product radio selector
const listenToVariationChange = () => {
  const containerFilter = document.querySelectorAll('.product-module__right');
  containerFilter.forEach((container) => {
    container.querySelectorAll('.product-module__right input').forEach((item) => {
      item.addEventListener('click', (event) => {
        if (item.name === 'cross-sell-product') {
          if (event.target.value) {
            window.location.href = event.target.value;
          }
        } else {
          if (item.name !== 'value') {
            item.closest('.radio-selector-group').querySelector('.radio-selector-group__title-text').innerHTML =
              item.dataset.text;
          }
          getVariation(item.closest('.product-popup'));
        }
      });
    });
  });
};

listenToVariationChange();

// **********************************************************
// Add to cart
// **********************************************************

// Open Cart Popup on add to cart success
const openCartPopupOnAddSuccess = (popupContent, popup = '', upsaleModal = '') => {
  const cartPopup = document.querySelector('.cart-popup');
  if (cartPopup) {
    const cartPopupContent = cartPopup.querySelector('.cart-popup__content');
    // Only update the content when called from the upsell modal
    if (upsaleModal) {
      cartPopupContent.innerHTML = popupContent;
      cartPopup.classList.remove('cart-popup--empty');
      animateLatestCart();
      return;
    }
    if (popup && popup.closest('.cart-popup')) {
      cartPopup.classList.remove('is-cart-open');
      document.querySelector('.cart-popup__close')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const isOpen = cartPopup.classList.contains('is-cart-open');
    cartPopupContent.innerHTML = popupContent;
    cartPopup.classList.remove('cart-popup--empty');
    cartPopup.classList.toggle('is-cart-open', !isOpen);
    toggleBodyScrollLock(!isOpen);
    animateLatestCart();
  }
};

// Add to cart axios
const axiosAddToCart = async (formData, formAction, popup) => {
  const nonce = 'nonce';
  const token = 'token';
  const formDataInput = new FormData();
  formDataInput.append('action', formAction);
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('nonce', nonce);
  formDataInput.append('token', token);

  try {
    const response = await axios.post(localData.apiURL, formDataInput);
    if (response.data.data.upsale_modal) {
      document.querySelector('.upgrade-modal')?.remove();
      const modalContainer = document.createElement('div');
      modalContainer.innerHTML = response.data.data.upsale_modal;
      const modal = modalContainer.firstElementChild;
      if (modal) {
        document.body.appendChild(modal);
        initProductSlider(modal);
        if (!document.querySelector('.cart-popup.is-cart-open')) {
          toggleBodyScrollLock(true);
        }
        modal.classList.add('is-open-modal');
      }
    }
    openCartPopupOnAddSuccess(response.data.data.cart_content_html, popup, response.data.data.upsale_modal);
    updateCartNumber(response.data.data.cart_contents_count);

    // GA4 add_to_cart (podatki s strežnika: getDataLayerItem)
    const addToCart = response.data.data.add_to_cart;
    if (addToCart) window.prowDL.pushEcommerce('add_to_cart', addToCart.ecommerce);
  } catch (err) {
    console.error(err);
  }
};

// Click on add to cart button
const handleAddToCartClick = (popup) => {
  const root = popup || document;
  const quantityCounterEle = root.querySelector('.quantity-counter__input') || root.querySelector('#quantity-counter');
  const variationId = root.querySelector('.variation-id')?.value || root.dataset?.variationId || 0;
  const prodId = root.querySelector('.product-id')?.value || root.dataset?.productId || 0;
  const addToCartData = {
    product_id: prodId,
    variation_id: variationId,
    quantity: quantityCounterEle?.value || 1,
    personalization: '',
    note: '',
    voucher_recipient_name: '',
    voucher_your_name: '',
  };
  const upsaleModal = document.querySelector('.upgrade-modal.is-open-modal');
  if (upsaleModal) {
    addToCartData.change_id = upsaleModal.querySelector('.upgrade-modal__suggestions')?.dataset.id;
    upsaleModal.classList.remove('is-open-modal');
  }
  axiosAddToCart(addToCartData, 'addToCart', popup);
};
attachEvent(
  '.product-module__add-to-cart:not(.is-disabled) a:not(.is-loading),' +
    ' .product-popup__add-to-cart .btn:not(.btn--disabled):not(.is-loading), .product-card' +
    ' .btn--large, .product-card .product-card__link, .product-small-card__btn span',
  'click',
  (ev) => {
    ev.preventDefault();
    handleAddToCartClick(
      ev.target.closest('.product-card') ??
        ev.target.closest('.product-popup') ??
        ev.target.closest('.product-small-card'),
    );
  },
);

// view_item pošlje scripts/04_analytics.js (localData.dl.product)
